import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/content";

const CHAPTERS = [
  {
    num: "01",
    title: "We drive to your spot",
    body: "No drop-offs, no waiting rooms. You pick the place — your driveway, your office lot, your apartment complex — and we show up ready to work.",
    image: IMAGES.detailer,
    alt: "Professional detailer at work on a vehicle",
  },
  {
    num: "02",
    title: "Deep interior care, done right",
    body: "Vacuumed carpets, conditioned leather, streak-free glass and a cabin that smells brand new. We treat every interior like it's our own ride.",
    image: IMAGES.leather,
    alt: "Clean leather car seats after detailing",
  },
  {
    num: "03",
    title: "Cash App & easy contact",
    body: "Pay the way that's easiest — we accept Cash App. One text books your detail, and one text gets you our $Cashtag for payment.",
    image: IMAGES.wipe,
    alt: "Detailing cloth wiping down a car interior",
  },
];

export const NumberedChapters = () => (
  <section className="border-t border-[#E5E7EB] bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal>
        <p className="font-mono-alt text-xs font-semibold uppercase tracking-[0.2em] text-[#B45309]">
          02 — How it works
        </p>
        <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-[#111827] sm:text-3xl lg:text-4xl">
          Simple from first text to final wipe.
        </h2>
      </Reveal>

      <div className="mt-16 space-y-0">
        {CHAPTERS.map((ch, i) => (
          <Reveal key={ch.num} delay={0.05}>
            <div
              className={`grid items-center gap-10 border-t border-[#E5E7EB] py-14 md:grid-cols-12 ${
                i % 2 === 1 ? "" : ""
              }`}
              data-testid={`chapter-${ch.num}`}
            >
              <div className={`md:col-span-2 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <span className="font-mono-alt text-5xl font-semibold text-[#E5E7EB] sm:text-6xl">{ch.num}</span>
              </div>
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-3" : ""}`}>
                <h3 className="font-display text-xl font-semibold tracking-tight text-[#111827] sm:text-2xl">
                  {ch.title}
                </h3>
                <p className="mt-4 max-w-md text-base leading-relaxed text-[#4B5563]">{ch.body}</p>
              </div>
              <div className={`md:col-span-4 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <div className="overflow-hidden rounded-2xl">
                  <img
                    src={ch.image}
                    alt={ch.alt}
                    loading="lazy"
                    className="h-52 w-full object-cover transition-transform duration-700 hover:scale-105"
                  />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
